<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content min-h-160px relative">
                <div class="bg-a-brown-f5ebdc w-full h-full rounded-10 p-6">
                    <div class="text-center text-xl pt-3" v-html="title"></div>
                    <div class="pt-3 pb-10 text-center text-14 text-a-brown-502314 break-words" v-html="message"></div>
                    <div class="flex justify-center">
                        <RedButton @click="clickOk()" :customClass="'w-200px py-2.5'">
                            <div class="">{{btnOk}}</div>
                        </RedButton>
                    </div>
                    <div class="flex justify-center pt-4">
                        <WhiteButton @click="clickCancel()" :customClass="'w-200px py-2.5'">
                            <div class="">{{btnCancel}}</div>
                        </WhiteButton>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// components
import RedButton from "@/components/Button/RedButton.vue";
import WhiteButton from "@/components/Button/WhiteButton.vue";

export default {
    name: "ConfirmTwoButtonModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components:{
        RedButton,
        WhiteButton
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
